import {
  ActionReducerMapBuilder,
  CreateSliceOptions,
  SliceCaseReducers,
  ValidateSliceCaseReducers,
  createSlice,
} from '@reduxjs/toolkit';

import { SliceReducers, SliceReturn, ValidateSliceReducers } from './create-app-slice.types';

export const createAppSlice = <T, Reducers extends SliceReducers<T>>({
  name,
  initialState,
  reducers,
  extraReducersBuilder,
}: {
  name: CreateSliceOptions['name'];
  initialState: T;
  reducers: ValidateSliceReducers<T, Reducers>;
  extraReducersBuilder?: (builder: ActionReducerMapBuilder<T>) => void;
}) => {
  return createSlice({
    name,
    initialState,
    reducers: reducers as ValidateSliceCaseReducers<T, SliceCaseReducers<T>>,
    extraReducers: builder => {
      extraReducersBuilder?.(builder);
    },
  }) as unknown as SliceReturn<T, ValidateSliceReducers<T, Reducers>>;
};
